"use strict";

function chunk(totalLength, chunkLength) {
  chunkLength = chunkLength || 64;
  return Math.ceil(totalLength / chunkLength);
}

module.exports = chunk;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/chunk.js
// module id = 582
// module chunks = 157